var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "otherBox" }, [
    _c(
      "div",
      { staticClass: "column" },
      [
        _c("div", { staticClass: "columnText2" }, [_vm._v(" 发票须知 ")]),
        _c("el-input", {
          staticClass: "columnText3",
          staticStyle: { flex: "1", "text-align": "center" },
          attrs: {
            disabled: _vm.disabled,
            size: "small",
            placeholder: "请输入发票须知",
            type: "text",
          },
          model: {
            value: _vm.datas.invoiceExplain,
            callback: function ($$v) {
              _vm.$set(_vm.datas, "invoiceExplain", $$v)
            },
            expression: "datas.invoiceExplain",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c("div", { staticClass: "columnText2" }, [_vm._v(" 其它须知 ")]),
        _c("el-input", {
          staticClass: "columnText3",
          staticStyle: { flex: "1", "text-align": "center" },
          attrs: {
            disabled: _vm.disabled,
            size: "small",
            placeholder: "请输入其他须知",
            type: "text",
          },
          model: {
            value: _vm.datas.otherExplain,
            callback: function ($$v) {
              _vm.$set(_vm.datas, "otherExplain", $$v)
            },
            expression: "datas.otherExplain",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c("div", { staticClass: "columnText2" }, [_vm._v(" 安全须知 ")]),
        _c("el-input", {
          staticClass: "columnText3",
          staticStyle: { flex: "1", "text-align": "center" },
          attrs: {
            disabled: _vm.disabled,
            size: "small",
            placeholder: "请输入安全须知",
            type: "text",
          },
          model: {
            value: _vm.datas.securityExplain,
            callback: function ($$v) {
              _vm.$set(_vm.datas, "securityExplain", $$v)
            },
            expression: "datas.securityExplain",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }